import { reviews } from '@/mocks/reviews';

export default function Reviews() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-medium rounded-full mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            500万+用户的深夜选择
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            每一个凌晨的订单背后，都有一个温暖的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.rating ? 'ri-star-fill text-primary-400' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 line-clamp-4">
                &ldquo;{review.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">{review.role} · {review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}